var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "issueListWrap",
    class: {
      active: _vm.status.issueListViewBln
    }
  }, [_vm.processDetail.processType == 'NORMAL' ? _c('div', {
    staticClass: "topInfo"
  }, [_c('div', {
    staticClass: "btn_area"
  }, [_c('div', {
    staticClass: "btn_area_left"
  }, [_c('span', {
    staticClass: "protocolCnt"
  }, [_vm._v("연결된 프로토콜 (" + _vm._s(_vm.connectedProtocolCount) + "개)")])])])]) : _vm._e(), _c('List', {
    attrs: {
      "protocolList": _vm.filterOfProtocols,
      "connectedProtocolCount": _vm.connectedProtocolCount
    },
    on: {
      "update:connectedProtocolCount": function ($event) {
        _vm.connectedProtocolCount = $event;
      },
      "update:connected-protocol-count": function ($event) {
        _vm.connectedProtocolCount = $event;
      }
    }
  }), _c('BtmComp', {
    attrs: {
      "isProtocol": true
    }
  }), _c('Loading', {
    attrs: {
      "visible": _vm.loading
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }